import { AppPermissions } from '@/config/app'
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { setupRouterHooks } from './hooks/index'

const BaseLayout = () => import('@/components/layout/default/index.vue')

const ProductRoutes: RouteRecordRaw = {
  path: '/product',
  name: 'product',
  redirect: { name: 'productIndex' },
  component: BaseLayout,
  meta: {
    deep: 1,
    title: '产品管理',
    isMenu: true,
    icon: 'icon-fenzhi',
  },
  children: [
    {
      path: '/search-product/index',
      name: 'productSearchIndex',
      component: () => import('@/views/product/search-product/index.vue'),
      meta: {
        deep: 2,
        title: '资源代号',
        isMenu: true,
        permissions: AppPermissions.ProductSearch,
      },
    },
    {
      path: '/product-sync/index',
      name: 'productSyncIndex',
      component: () => import('@/views/product/product-sync/index.vue'),
      meta: {
        deep: 2,
        title: '美服同步',
        isMenu: true,
        permissions: AppPermissions.ProductSync,
      },
    },

    {
      path: '/product/index',
      name: 'productIndex',
      component: () => import('@/views/product/index.vue'),
      meta: {
        deep: 2,
        title: '产品',
        isMenu: true,
        permissions: AppPermissions.Product,
      },
    },
    {
      path: '/product/:productId(\\d+)',
      name: 'product',
      component: () => import('@/views/product/detail.vue'),
      children: [
        {
          path: 'firmware',
          name: 'productFirmware',
          component: () => import('@/views/product/firmware/index.vue'),
          meta: {
            deep: 3,
            title: '产品固件管理',
            permissions: AppPermissions.ProductApps,
          },
        },
        {
          path: 'rule',
          name: 'publicRule',
          component: () => import('@/views/product/rule/index.vue'),
          meta: {
            deep: 3,
            title: '产品发布策略',
            permissions: AppPermissions.PublishRule,
          },
        },
        {
          path: 'config',
          name: 'productConfig',
          component: () => import('@/views/product/config/index.vue'),
          meta: {
            deep: 3,
            title: '配置管理',
            permissions: AppPermissions.ProductConfig,
          },
        },
        {
          path: 'ota',
          name: 'productOTA',
          component: () => import('@/views/product/ota/index.vue'),
          meta: {
            deep: 3,
            title: '产品OTA',
            permissions: AppPermissions.ProductOTA,
          },
        },
        {
          path: 'user',
          name: 'productUser',
          component: () => import('@/views/product/user/index.vue'),
          meta: {
            deep: 3,
            title: '授权管理',
            permissions: AppPermissions.ProductUser,
          },
        },
        {
          path: 'schema',
          name: 'productSchema',
          component: () => import('@/views/product/schema/index.vue'),
          meta: {
            deep: 3,
            title: '产品物模型',
            permissions: AppPermissions.ProductSchema,
          },
        },
      ],
      meta: {
        deep: 2,
        title: '产品详情',
        back: true,
        permissions: AppPermissions.Product,
      },
    },

    {
      path: '/firmware/index',
      name: 'firmwareIndex',
      component: () => import('@/views/firmware/index.vue'),
      meta: {
        deep: 2,
        title: '固件',
        isMenu: true,
        permissions: AppPermissions.Application,
      },
    },

    {
      path: '/firmware/:appId(\\d+)',
      name: 'firmware',
      component: () => import('@/views/firmware/detail.vue'),
      meta: {
        deep: 2,
        title: '固件详情',
        back: true,
        permissions: AppPermissions.Application,
      },
      children: [
        {
          path: 'version',
          name: 'firmwareVersion',
          component: () => import('@/views/firmware/version/index.vue'),
          meta: {
            deep: 3,
            title: '固件版本',
            permissions: AppPermissions.AppVersion,
          },
        },
        {
          path: 'config',
          name: 'firmwareConfig',
          component: () => import('@/views/firmware/config/index.vue'),
          meta: {
            deep: 3,
            title: '配置管理',
            permissions: AppPermissions.AppConfig,
          },
        },
        {
          path: 'user',
          name: 'firmwareUser',
          component: () => import('@/views/product/user/index.vue'),
          meta: {
            deep: 3,
            title: '授权管理',
            permissions: AppPermissions.AppUser,
          },
        },
        {
          path: 'product',
          name: 'firmwareProduct',
          component: () => import('@/views/firmware/product/index.vue'),
          meta: {
            deep: 3,
            title: '固件所属产品',
            permissions: AppPermissions.AppProduct,
          },
        },
      ],
    },
    {
      path: '/scene/index',
      name: 'sceneIndex',
      component: () => import('@/views/scene/index.vue'),
      meta: {
        deep: 2,
        title: '场景',
        isMenu: true,
        permissions: AppPermissions.Scene,
      },
    },
    {
      path: '/scene/detail',
      name: 'sceneDetail',
      component: () => import('@/views/scene/detail.vue'),
      meta: {
        deep: 2,
        title: '场景',
        isMenu: true,
        permissions: AppPermissions.Scene,
      },
      children: [
        {
          path: 'version',
          name: 'sceneVersion',
          component: () => import('@/views/scene/version/index.vue'),
          meta: {
            deep: 3,
            title: '场景版本',
            isMenu: true,
            permissions: [],
          },
        },
        {
          path: 'product',
          name: 'sceneProduct',
          component: () => import('@/views/scene/product/index.vue'),
          meta: {
            deep: 3,
            title: '场景关联产品',
            isMenu: true,
            permissions: [],
          },
        },
        {
          path: 'rule',
          name: 'sceneRule',
          component: () => import('@/views/scene/rule/index.vue'),
          meta: {
            deep: 3,
            title: '场景发布策略',
            isMenu: true,
            permissions: [],
          },
        },
      ],
    },
  ],
}

const DashboardRoutes: RouteRecordRaw = {
  path: '/dashboard',
  name: 'Dashboard',
  redirect: { name: 'productDashboardIndex' },
  component: BaseLayout,
  meta: {
    deep: 1,
    title: '看板展示',
    isMenu: true,
    icon: 'icon-fenzhi',
  },
  children: [


    {
      path: '/product-dashboard/index',
      name: 'productDashboardIndex',
      component: () => import('@/views/product/product-dashboard/index.vue'),
      meta: {
        deep: 2,
        title: '产品看板',
        isMenu: true,
        permissions: AppPermissions.ProductDashboard,
      },
    },


    {
      path: '/product-dashboard/:productUuid/:productId',
      name: 'productDashboardDetail',
      props: true,
      component: () => import('@/views/product/product-dashboard/detail.vue'),
      meta: {
        deep: 3,
        title: '查看OTA',
        back: true,
        permissions: AppPermissions.ProductDashboard,
      },
    },

    {
      path: '/firmware-dashboard/index',
      name: 'FirmwareboardIndex',
      component: () => import('@/views/product/firmware-dashboard/index.vue'),
      meta: {
        deep: 2,
        title: '固件看板',
        isMenu: true,
        permissions: AppPermissions.firmwareDashboard,
      },
    },

    {
      path: '/dashboard/ota-compare',
      name: 'OtaCompare',
      component: () => import('@/views/product/board-tools/OtaCompare.vue'),
      meta: {
        deep: 2,
        title: 'OTA版本对比',
        isMenu: true,
        permissions: AppPermissions.ProductDashboard,
      },
    },

    {
      path: '/dashboard/release-timeline',
      name: 'ReleaseTimeline',
      component: () => import('@/views/product/board-tools/ReleaseTimeline.vue'),
      meta: {
        deep: 2,
        title: 'OTA/固件时间线',
        isMenu: true,
        permissions: AppPermissions.ProductDashboard,
      },
    },


    {
      path: '/firmware-dashboard/:appId(\\d+)',
      name: 'firmwareDashboard',
      component: () => import('@/views/product/firmware-dashboard/detail.vue'),
      meta: {
        deep: 2,
        title: '固件详情',
        back: true,
        permissions: AppPermissions.firmwareDashboard,
      },
      children: [
        {
          path: 'version',
          name: 'firmwareDashboardVersion',
          component: () => import('@/views/product/firmware-dashboard/version/index.vue'),
          meta: {
            deep: 3,
            title: '固件版本',
            permissions: AppPermissions.firmwareDashboard,
          },
        },
      ],
    },













  ],
}


const ticketRoutes: RouteRecordRaw = {
  path: '/audit',
  name: 'Ticket',
  redirect: { name: 'OTAApproval' },
  component: BaseLayout,
  meta: {
    deep: 1,
    title: '审计',
    isMenu: true,
    icon: 'icon-fenzhi',
  },
  children: [


    {
      path: '/audit/ota_approval',
      name: 'OTAApproval',
      component: () => import('@/views/release-approval/release-approval.vue'),
      meta: {
        deep: 2,
        title: 'OTA审批',
        isMenu: true,
        permissions: AppPermissions.ReviewWoTA,
      },
    },














  ],
}



const DeviceRoutes: RouteRecordRaw = {
  path: '/device',
  name: 'device',
  redirect: { name: 'deviceSearch' },
  component: BaseLayout,
  meta: {
    deep: 1,
    title: '设备管理',
    isMenu: true,
    icon: 'icon-fenzhi',
    back: true,
  },
  children: [
    {
      path: '/device/search',
      name: 'deviceSearch',
      component: () => import('@/views/device/manage.vue'),
      meta: {
        deep: 2,
        title: '设备查询',
        isMenu: true,
        permissions: AppPermissions.DeviceSearch,
        onlysearch: true,
      },
    },
    {
      path: '/device/search/history/:deviceId',
      name: 'deviceHistorySearch',
      component: () => import('@/views/device/history.vue'),
      meta: {
        deep: 3,
        title: '设备历史记录',
        permissions: AppPermissions.DeviceSearch,
      },
    },
    {
      path: '/device/manage',
      name: 'deviceManage',
      component: () => import('@/views/device/manage.vue'),
      meta: {
        deep: 2,
        title: '设备列表',
        isMenu: true,
        permissions: AppPermissions.DeviceManage,
        keepAlive: true,
      },
    },
    {
      path: '/device/manage/history/:deviceId',
      name: 'deviceHistory',
      component: () => import('@/views/device/history.vue'),
      meta: {
        deep: 3,
        title: '设备历史记录',
        permissions: AppPermissions.DeviceManage,
      },
    },
  ],
}

const APKRoutes: RouteRecordRaw = {
  path: '/apk',
  name: 'apk',
  redirect: { name: 'apkIndex' },
  component: BaseLayout,
  meta: {
    deep: 1,
    title: '产品管理',
    icon: 'icon-fenzhi',
    isMenu: true,
  },
  children: [
    {
      path: '/apk/index',
      name: 'apkIndex',
      component: () => import('@/views/apk/index.vue'),
      meta: {
        deep: 2,
        title: 'APP',
        permissions: AppPermissions.APK,
        isMenu: true,
      },
    },
    {
      path: '/apk/:apkUuid',
      name: 'apk',
      component: () => import('@/views/apk/detail.vue'),
      meta: {
        deep: 2,
        title: '产品详情',
        back: true,
        permissions: AppPermissions.APK,
      },
      children: [
        {
          path: 'version',
          name: 'apkVersion',
          component: () => import('@/views/apk/version/index.vue'),
          meta: {
            deep: 3,
            title: '产品OTA',
            permissions: AppPermissions.APKVersion,
            isMenu: true,
          },
        },
        {
          path: 'rule',
          name: 'apkRule',
          component: () => import('@/views/apk/rule/index.vue'),
          meta: {
            deep: 3,
            title: '产品发布策略',
            permissions: AppPermissions.APKRule,
          },
        },
        {
          path: 'config',
          name: 'apkConfig',
          component: () => import('@/views/apk/config/index.vue'),
          meta: {
            deep: 3,
            title: 'APP发布策略',
            permissions: [],
          },
        },
        {
          path: 'firmware',
          name: 'apkFirmware',
          component: () => import('@/views/apk/firmware/index.vue'),
          meta: {
            deep: 3,
            title: 'APP固件管理',
            permissions: [],
          },
        },
      ],
    },
  ],
}

const I18nRoutes: RouteRecordRaw = {
  path: '/i18n',
  name: 'i18n',
  redirect: { name: 'i18nProduct' },
  component: BaseLayout,
  meta: {
    deep: 1,
    title: '文案翻译',
    isMenu: true,
    icon: 'icon-fenzhi',
  },
  children: [
    {
      path: '/i18n/product',
      name: 'i18nProduct',
      component: () => import('@/views/i18n/product.vue'),
      meta: {
        deep: 2,
        title: '产品文案',
        isMenu: true,
        permissions: AppPermissions.I18nProduct,
      },
    },
    {
      path: '/i18n/firmware',
      name: 'i18nFirmware',
      component: () => import('@/views/i18n/firmware.vue'),
      meta: {
        deep: 2,
        title: '固件文案',
        isMenu: true,
        permissions: AppPermissions.I18nFirmware,
      },
    },
    {
      path: '/i18n/apk',
      name: 'i18nApk',
      component: () => import('@/views/i18n/apk.vue'),
      meta: {
        deep: 2,
        title: 'APP 文案',
        isMenu: true,
        permissions: AppPermissions.I18nApk,
      },
    },
  ],
}

const IAMRoutes: RouteRecordRaw = {
  path: '/iam',
  name: 'iam',
  redirect: { name: 'iamOrg' },
  component: BaseLayout,
  meta: {
    deep: 1,
    title: '授权管理',
    isMenu: true,
    icon: 'icon-fenzhi',
  },
  children: [
    {
      path: '/iam/org',
      name: 'iamOrg',
      component: () => import('@/views/iam/index.vue'),
      meta: {
        deep: 2,
        title: '成员与部门',
        isMenu: true,
        permissions: AppPermissions.OrgPage,
      },
    },
    {
      path: '/iam/permission',
      name: 'iamPermission',
      component: () => import('@/views/iam/index.vue'),
      meta: {
        deep: 2,
        title: '角色与权限',
        isMenu: true,
        permissions: AppPermissions.RolePage,
      },
    },
  ],
}

const upGradRoutes: RouteRecordRaw = {
  path: '/upgrad',
  name: 'upgrad',
  component: BaseLayout,
  meta: {
    deep: 1,
    title: '升级记录',
    isMenu: true,
    icon: 'icon-fenzhi',
  },
  children: [
    {
      path: '/upgrad/x5grad',
      name: 'x5grad',
      component: () => import('@/views/upgrad/x5grad/x5grad.vue'),
      meta: {
        deep: 2,
        title: 'X5平台',
        isMenu: true,
        permissions: AppPermissions.RecordX5,
      },
    },
    {
      path: '/upgrad/xosgrad',
      name: 'xosgrad',
      component: () => import('@/views/upgrad/xosgrad/xosgrad.vue'),
      meta: {
        deep: 2,
        title: 'XOS平台',
        isMenu: true,
        permissions: AppPermissions.RecordX5,
      },
    },
    // {
    //   path: '/upgrad/lsgrad',
    //   name: 'lsgrad',
    //   component: () => import('@/views/upgrad/lsgrad/lsgrad.vue'),
    //   meta: {
    //     deep: 2,
    //     title: 'LS平台',
    //     isMenu: true,
    //     permissions: [],
    //   }
    // }
  ],
}

export const MainRoutes: RouteRecordRaw[] = [

  ProductRoutes,
  DeviceRoutes,
  APKRoutes,
  I18nRoutes,
  IAMRoutes,
  upGradRoutes,
    ticketRoutes,
  DashboardRoutes,
]

const CommonRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/common/login.vue'),
    meta: {
      deep: 1,
      title: '登录',
      isNeedLogin: false,
    },
  },
  {
    path: '/redirect',
    name: 'redirect',
    component: () => import('@/views/common/redirect.vue'),
    meta: {
      deep: 1,
      title: '设备运维平台',
      isNeedLogin: false,
    },
  },
  {
    path: '/tools/json',
    name: 'tools-json',
    component: () => import('@/views/common/tools/json.vue'),
    meta: {
      deep: 1,
      title: 'Json-Schema工具',
      isNeedLogin: false,
    },
  },
  {
    path: '/tools/share',
    name: 'tools-share',
    component: () => import('@/views/common/tools/share.vue'),
    meta: {
      deep: 1,
      title: '物模型预览',
      isNeedLogin: false,
    },
  },
  {
    path: '/403',
    name: '403',
    component: () => import('@/views/common/404.vue'),
    meta: {
      deep: 1,
      title: '缺少访问权限',
      isNeedLogin: false,
    },
  },
  {
    path: '/500',
    name: '500',
    component: () => import('@/views/common/404.vue'),
    meta: {
      deep: 1,
      title: '服务器异常',
      isNeedLogin: false,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: () => import('@/views/common/404.vue'),
    meta: {
      deep: 1,
      title: '页面不存在',
      isNeedLogin: false,
    },
  },
]

export function getHomeRoute(redirectUrl: string) {
  return {
    path: '/',
    name: 'home',
    redirect: redirectUrl,
    meta: {
      deep: 1,
      title: '首页',
    },
  }
}

const baseUrl = import.meta.env.VITE_ROUTE_BASE_PATH || `/`
export const router = createRouter({
  history: createWebHistory(baseUrl),
  linkActiveClass: 'active',
  routes: [...CommonRoutes],
})

setupRouterHooks(router)
